import { IFormConfigItem } from 'src/app/types/IFormConfigs';
import KurvBasicInformationForm from './KurvBasicInformationForm';
import KurvAccountProcessingForm from './KurvAccountProcessingForm';
import KurvBusinessComplianceForm from './KurvBusinessComplianceForm';
import KurvSalesAndTransactionsForm from './KurvSalesAndTransactionsForm';
import KurvEquipmentForm from './KurvEquipmentForm';
import { IOffersItem } from 'src/app/types';

export const kurvFormConfig: IFormConfigItem<IOffersItem>[] = [
  {
    title: 'Basic Information',
    text: 'Gather Business Information',
    form: (setNextForm, setPrevForm) => (
      <KurvBasicInformationForm index={0} setNextForm={setNextForm} setPrevForm={setPrevForm!} />
    ),
  },
  {
    title: 'Account Processing',
    text: 'Confirm Account Details',
    form: (setNextForm, setPrevForm) => (
      <KurvAccountProcessingForm index={1} setNextForm={setNextForm} setPrevForm={setPrevForm!} />
    ),
  },
  {
    title: 'Business Compliance',
    text: 'Ensure Regulatory Compliance',
    form: (setNextForm, setPrevForm) => (
      <KurvBusinessComplianceForm index={2} setNextForm={setNextForm} setPrevForm={setPrevForm!} />
    ),
  },
  {
    title: 'Sales and Transactions',
    text: 'Capture Sales Information',
    form: (setNextForm, setPrevForm) => (
      <KurvSalesAndTransactionsForm index={3} setNextForm={setNextForm} setPrevForm={setPrevForm!} />
    ),
  },
  {
    title: 'Equipment',
    text: 'Hardware Details',
    form: (setNextForm, setPrevForm, offer) => (
      <KurvEquipmentForm
        index={4}
        setNextForm={setNextForm}
        setPrevForm={setPrevForm!}
        offer={offer!}
      />
    ),
  },
];
